import { query, post } from '@/services/api/backendGateway'
import { fetchUserCategories } from '@/services/categoryApi'

const EXPLORE_API = '/explore/'

export async function fetchExplorePage({ search = undefined, page = 1, sort = 'recent', min_cards = undefined, max_cards = undefined, subject = undefined } = {}) {
  return (await query(EXPLORE_API, { search, page, sort, min_cards, max_cards, subject })) || {}
}

export async function fetchExploreByCode(code) {
  return query(EXPLORE_API, { code })
}

export async function fetchFoldersWithUpdates() {
  const response = await query(EXPLORE_API, { check_updates: true })
  return response?.folder_ids_with_updates || []
}

export async function syncFolderById(folderId) {
  const response = await post(EXPLORE_API, {
    action: 'sync',
    folder_id: folderId
  })
  return response.response
}

export async function importFolderByCode({ sourceCode, category = 'null' }) {
  return post(EXPLORE_API, {
    source_code: sourceCode,
    category
  })
}

export async function loadImportPreviewAndCategories(code) {
  const [preview, categories] = await Promise.all([
    fetchExploreByCode(code),
    fetchUserCategories()
  ])
  return { preview, categories }
}
